import React, { useContext } from 'react';
import { bool, func, number, element } from 'prop-types';
import classNames from 'classnames';

import { Col } from '@thd-olt-component-react/grid';
import { Image } from '@thd-olt-component-react/image';

import { ProductRating } from '../product-rating/ProductRating';
import { ProductPodContext } from '../../ProductPodContext';
import { ProductImage } from '../product-image/ProductImage';
import { ProductHeader } from '../product-header/ProductHeader';
import { ProductPrice } from '../product-price/ProductPrice';
import { ProductATC } from '../product-atc/ProductATC';
import { isATCEnabled } from '../../utils';

import './product-mini.scss';

export const ProductMini = (props) => {
  const {
    disabled,
    onAction,
    enableATC,
    silentATC,
    onlyShowIfFulfillable,
    inCartQuantity,
    callToActionSection
  } = props;

  const { product } = useContext(ProductPodContext);

  if (onlyShowIfFulfillable && !isATCEnabled(product)) {
    return null;
  }

  const mainSectionClasses = classNames('product-pod-mini__main', {
    'product-pod-mini__main--withATC': enableATC
  });

  return (
    <div className="product-pod-mini">
      <div>
        <Col fallback="3" className="product-pod-mini__image">
          <ProductImage inCartQuantity={inCartQuantity} />
        </Col>
        <Col fallback="8" className={mainSectionClasses}>
          <ProductHeader brand="inline" collection="hidden" />
          <ProductRating />
          <ProductPrice large={false} hideBadge hidePromotions hideBulkPrice />
          {enableATC && <ProductATC disabled={disabled} silent={silentATC} outline />}
        </Col>
        <Col fallback="1" className="product-pod-mini__caret">
          <Image
            onClick={onAction}
            className="product-pod-mini__caret__image"
            alt="caret"
            src="https://assets.homedepot-static.com/images/v1/caret-orange.svg"
          />
        </Col>
      </div>
      {!enableATC && callToActionSection}
      <div />
    </div>
  );
};

ProductMini.displayName = 'ProductMini';

ProductMini.propTypes = {
  disabled: bool,
  onAction: func,
  enableATC: bool,
  silentATC: bool,
  onlyShowIfFulfillable: bool,
  inCartQuantity: number,
  callToActionSection: element
};

ProductMini.defaultProps = {
  disabled: false,
  onAction: () => {},
  enableATC: true,
  silentATC: false,
  onlyShowIfFulfillable: false,
  inCartQuantity: 0,
  callToActionSection: null
};
